import { ReactComponent as CPUSvg } from "./cpu.svg";

const NewSessionAvailable = ({ newSessionUrl }) => {
  const today = new Date();
  const formattedDate = today.toLocaleDateString('en-US', {
    month: 'numeric',
    day: 'numeric',
    year: 'numeric'
  });

  return (
    <article className="vh-100 dt w-100">
      <div className="dtc v-mid tc white ph3 ph4-l">
        <h1 className="f1 lh-title near-black">New Application Available</h1>
        <CPUSvg />
        <div className="center tc mw7">
          <p className="f3 lh-copy near-black measure mb4">
            Your previous application session has expired. A new application is ready with updated assignment dates that start today – <b>{formattedDate}</b>.
          </p>
          <a
            href={newSessionUrl}
            className="f4 link dim br2 ph3 pv2 mb2 dib white bg-black"
          >
            Start New Application
          </a>
        </div>
      </div>
    </article>
  );
};

export default NewSessionAvailable; 